// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"86de79d6","509":"9b4329df"}[chunkId] + ".chunk.css";
};